import * as Sentry from '@sentry/browser'
import type { PageContextClient } from 'vike/types'

import { isThirdPartyError } from './isThirdPartyError'

let sentryInitialized = false
let preloadErrorListenerAdded = false

export default function onBeforeRenderClient(pageContext: PageContextClient) {
  if (!preloadErrorListenerAdded) {
    window.addEventListener('vite:preloadError', () => {
      if (!sessionStorage.getItem('vite:preloadError:reloaded')) {
        sessionStorage.setItem('vite:preloadError:reloaded', '1')
        window.location.reload()
      }
    })
    preloadErrorListenerAdded = true
  }

  if (!sentryInitialized && pageContext.sentryDsn) {
    Sentry.init({
      dsn: pageContext.sentryDsn,
      environment: pageContext.env || 'development',
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.1,
      beforeSend(event) {
        const reason = isThirdPartyError(
          event,
          window.location.origin,
          import.meta.env.BASE_URL
        )
        if (reason) {
          console.info(
            '[sentry] Dropped third-party error:',
            reason,
            event.exception?.values?.[0]?.value
          )
          return null
        }
        return event
      },
    })
    sentryInitialized = true
  }
}
